import { DrumsHiHat } from "./drums_hihat";
import { DrumsKick } from "./drums_kick";
import { DrumsSnare } from "./drums_snare";

export {
  DrumsHiHat,
  DrumsKick,
  DrumsSnare,
};
